import { Grid2x2, Lock } from "lucide-react";

import { EmptyState, PageHead } from "src/components/common";

/**
 * Payouts is locked/not-yet-released (it shows a lock in the sidebar). The prototype has no
 * design for it either, so this is a coming-soon state built from the design system.
 */
const Payouts = () => (
	<div className="tw-space-y-5">
		<PageHead title="Payouts" subtitle="Send money out of your Paylinq balance." />

		<div className="tw-rounded-lg tw-border tw-border-border tw-bg-white tw-shadow-card">
			<EmptyState
				icon={Grid2x2}
				title="Payouts is coming soon"
				description="You'll be able to pay suppliers and staff directly from your Paylinq balance. We'll let you know the moment it's ready."
				action={
					<span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-bg-slate-tint tw-px-3 tw-py-1.5 tw-text-[12.5px] tw-font-semibold tw-text-slate">
						<Lock className="tw-h-3.5 tw-w-3.5" />
						Not yet available
					</span>
				}
			/>
		</div>
	</div>
);

export default Payouts;
